import React, { useState, useEffect } from "react";
import { Typography, Box } from "@mui/material";


const GalleryCarousel = ({ images = [] }) => {
    const [current, setCurrent] = useState(0);

    // Auto slide
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrent((prev) => (prev + 1) % images.length);
        }, 3500);

        return () => clearInterval(interval);
    }, [images.length]);

    return (
        <Box
            sx={{
                width: "100%",
                p: 3,
                //backgroundColor: '#fff9f1',
                position: "relative",
            }}
        >
        
            {/* Carousel Container */}
            <Box
                sx={{
                    position: "relative",
                    height: "350px",
                    borderRadius: "20px",
                    overflow: "hidden",
                }}
            >
                {images.map((img, index) => (
                    <Box
                        key={index}
                        sx={{
                            position: "absolute",
                            width: "100%",
                            height: "100%",
                            top: 0,
                            left: 0,
                            opacity: current === index ? 1 : 0,
                            transition: "opacity 0.8s ease-in-out",
                        }}
                    >
                        <img
                            src={img}
                            alt={`slide-${index}`}
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                            }}
                        />
                    </Box>
                ))}
            </Box>

            {/* Dots */}
            <Box
                sx={{
                    mt: 2,
                    display: "flex",
                    justifyContent: "center",
                }}
            >
                {images.map((_, index) => (
                    <Box
                        key={index}
                        sx={{
                            width: current === index ? "10px" : "8px",
                            height: current === index ? "10px" : "8px",
                            bgcolor: current === index ? "#444" : "#bbb",
                            borderRadius: "50%",
                            cursor: "pointer",
                            transition: "0.3s",
                            mx: "5px"
                        }}
                    />
                ))}
            </Box>
        </Box>
    );
};

export default GalleryCarousel;
